import { Account } from '../models/account.model';

export const getProductCatalogVersion = (
  account: Account
): string | undefined => {
  return account?.pricing_table?.product_catalog_version;
};
